import type { GraphQLClient, RequestOptions } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type SDK_AiChatMessageInput = {
  content: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type SDK_AiChatResponse = {
  __typename?: 'AiChatResponse';
  explanation: Scalars['String']['output'];
  jadle: Scalars['String']['output'];
};

export type SDK_AiChatResult = SDK_AiChatResponse | SDK_StackErrorMessage;

export enum SDK_Align {
  Center = 'center',
  End = 'end',
  Justify = 'justify',
  Start = 'start',
  Unset = 'unset'
}

export type SDK_AudioFileInput = {
  altText: Scalars['String']['input'];
  url: Scalars['String']['input'];
  userDefinedName: Scalars['String']['input'];
};

export type SDK_AudioPlayer = {
  __typename?: 'AudioPlayer';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  weight: SDK_FontWeight;
};

export type SDK_AudioPlayerInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  weight: SDK_FontWeight;
};

export type SDK_Blank = {
  __typename?: 'Blank';
  fontSize: SDK_FontSizeChoice;
  leading: Scalars['Float']['output'];
};

export type SDK_BlankInput = {
  fontSize: SDK_FontSizeChoice;
  leading: Scalars['Float']['input'];
};

export type SDK_Box = {
  __typename?: 'Box';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  weight: SDK_FontWeight;
};

export type SDK_BoxInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  weight: SDK_FontWeight;
};

export type SDK_Bullet = {
  __typename?: 'Bullet';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  markerColor?: Maybe<SDK_ColorChoice>;
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  space?: Maybe<Scalars['Float']['output']>;
  weight: SDK_FontWeight;
};

export type SDK_BulletInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  markerColor?: InputMaybe<SDK_ColorChoice>;
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  space?: InputMaybe<Scalars['Float']['input']>;
  weight: SDK_FontWeight;
};

export type SDK_Button = {
  __typename?: 'Button';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  weight: SDK_FontWeight;
};

export type SDK_ButtonInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  weight: SDK_FontWeight;
};

export type SDK_Caption = {
  __typename?: 'Caption';
  align: SDK_Align;
  backdropOpacity: Scalars['Float']['output'];
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  weight: SDK_FontWeight;
};

export type SDK_CaptionInput = {
  align: SDK_Align;
  backdropOpacity: Scalars['Float']['input'];
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  weight: SDK_FontWeight;
};

export type SDK_Cell = {
  __typename?: 'Cell';
  align: SDK_Align;
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  startingPoint: SDK_StartingPoint;
};

export type SDK_CellInput = {
  align: SDK_Align;
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  startingPoint: SDK_StartingPoint;
};

/**
 * chart: element — series hues for multi-series charts.
 * A single series always draws in the filter ink (colors.first).
 */
export type SDK_ChartFilter = {
  __typename?: 'ChartFilter';
  colors: Array<Scalars['String']['output']>;
};

export type SDK_ChartFilterInput = {
  colors: Array<Scalars['String']['input']>;
};

export enum SDK_ColorChoice {
  Eighth = 'eighth',
  Fifth = 'fifth',
  First = 'first',
  Fourth = 'fourth',
  Second = 'second',
  Seventh = 'seventh',
  Sixth = 'sixth',
  Third = 'third',
  Unset = 'unset'
}

export type SDK_Colors = {
  __typename?: 'Colors';
  eighth?: Maybe<Scalars['String']['output']>;
  fifth?: Maybe<Scalars['String']['output']>;
  first: Scalars['String']['output'];
  fourth?: Maybe<Scalars['String']['output']>;
  second: Scalars['String']['output'];
  seventh?: Maybe<Scalars['String']['output']>;
  sixth?: Maybe<Scalars['String']['output']>;
  third?: Maybe<Scalars['String']['output']>;
};

export type SDK_ColorsInput = {
  eighth?: InputMaybe<Scalars['String']['input']>;
  fifth?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['String']['input'];
  fourth?: InputMaybe<Scalars['String']['input']>;
  second: Scalars['String']['input'];
  seventh?: InputMaybe<Scalars['String']['input']>;
  sixth?: InputMaybe<Scalars['String']['input']>;
  third?: InputMaybe<Scalars['String']['input']>;
};

export type SDK_ColumnTitle = {
  __typename?: 'ColumnTitle';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  weight: SDK_FontWeight;
};

export type SDK_ColumnTitleInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  weight: SDK_FontWeight;
};

export type SDK_DataFileInput = {
  altText: Scalars['String']['input'];
  url: Scalars['String']['input'];
  userDefinedName: Scalars['String']['input'];
};

export type SDK_Error = {
  __typename?: 'Error';
  error: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type SDK_FileErrorMessage = {
  __typename?: 'FileErrorMessage';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SDK_FileInput = {
  altText: Scalars['String']['input'];
  url: Scalars['String']['input'];
  userDefinedName: Scalars['String']['input'];
};

export type SDK_FileResult = SDK_FileErrorMessage | SDK_QpFile;

export type SDK_FileUpdateResponse = {
  __typename?: 'FileUpdateResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SDK_Filter = {
  __typename?: 'Filter';
  align: SDK_Align;
  audioPlayer: SDK_AudioPlayer;
  autospace: Scalars['Boolean']['output'];
  background: Scalars['String']['output'];
  blank: SDK_Blank;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  box: SDK_Box;
  bullet: SDK_Bullet;
  button: SDK_Button;
  caption: SDK_Caption;
  cell: SDK_Cell;
  /** required — the get-filter resolver backfills the template default for filters stored before charts existed */
  chart: SDK_ChartFilter;
  color: Scalars['String']['output'];
  colors: SDK_Colors;
  columnTitle: SDK_ColumnTitle;
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  filterName: Scalars['String']['output'];
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontSizes: SDK_FontSizes;
  fontStyle: SDK_FontStyle;
  fonts: SDK_Fonts;
  frame: SDK_Frame;
  grid: SDK_Grid;
  image: SDK_ImageFilter;
  line: SDK_Line;
  lineHeightMultiplier: Scalars['Float']['output'];
  link: SDK_Link;
  list: SDK_List;
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  ownerName: Scalars['String']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  paragraph: SDK_Paragraph;
  publish: Scalars['Boolean']['output'];
  read: SDK_Read;
  startingPoint: SDK_StartingPoint;
  stickyFooter: SDK_StickyFooter;
  stickyHeader: SDK_StickyHeader;
  subtitle: SDK_SubTitle;
  supertitle: SDK_SuperTitle;
  table: SDK_Table;
  tableCell: SDK_TableCell;
  title: SDK_Title;
  weight: SDK_FontWeight;
};

export type SDK_FilterName = {
  __typename?: 'FilterName';
  filterName?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
};

export type SDK_FilterUpdateResponse = {
  __typename?: 'FilterUpdateResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum SDK_FlexDirection {
  Column = 'column',
  ColumnReverse = 'columnReverse',
  Row = 'row',
  RowReverse = 'rowReverse',
  Unset = 'unset'
}

export type SDK_Font = {
  __typename?: 'Font';
  fontData?: Maybe<Scalars['String']['output']>;
  fontName: Scalars['String']['output'];
};

export enum SDK_FontChoice {
  Eighth = 'eighth',
  Fifth = 'fifth',
  First = 'first',
  Fourth = 'fourth',
  Second = 'second',
  Seventh = 'seventh',
  Sixth = 'sixth',
  Third = 'third'
}

export enum SDK_FontSizeChoice {
  Eighth = 'eighth',
  Fifth = 'fifth',
  First = 'first',
  Fourth = 'fourth',
  Second = 'second',
  Seventh = 'seventh',
  Sixth = 'sixth',
  Third = 'third'
}

export type SDK_FontSizes = {
  __typename?: 'FontSizes';
  eighth?: Maybe<Scalars['Float']['output']>;
  fifth?: Maybe<Scalars['Float']['output']>;
  first: Scalars['Float']['output'];
  fourth?: Maybe<Scalars['Float']['output']>;
  second?: Maybe<Scalars['Float']['output']>;
  seventh?: Maybe<Scalars['Float']['output']>;
  sixth?: Maybe<Scalars['Float']['output']>;
  third?: Maybe<Scalars['Float']['output']>;
};

export type SDK_FontSizesInput = {
  eighth?: InputMaybe<Scalars['Float']['input']>;
  fifth?: InputMaybe<Scalars['Float']['input']>;
  first: Scalars['Float']['input'];
  fourth?: InputMaybe<Scalars['Float']['input']>;
  second?: InputMaybe<Scalars['Float']['input']>;
  seventh?: InputMaybe<Scalars['Float']['input']>;
  sixth?: InputMaybe<Scalars['Float']['input']>;
  third?: InputMaybe<Scalars['Float']['input']>;
};

export enum SDK_FontStyle {
  Italic = 'italic',
  Normal = 'normal',
  Unset = 'unset'
}

export enum SDK_FontWeight {
  Bold = 'bold',
  Bolder = 'bolder',
  Lighter = 'lighter',
  Normal = 'normal',
  Unset = 'unset'
}

export type SDK_Fonts = {
  __typename?: 'Fonts';
  eighth?: Maybe<Scalars['String']['output']>;
  fifth?: Maybe<Scalars['String']['output']>;
  first: Scalars['String']['output'];
  fourth?: Maybe<Scalars['String']['output']>;
  second?: Maybe<Scalars['String']['output']>;
  seventh?: Maybe<Scalars['String']['output']>;
  sixth?: Maybe<Scalars['String']['output']>;
  third?: Maybe<Scalars['String']['output']>;
};

export type SDK_FontsInput = {
  eighth?: InputMaybe<Scalars['String']['input']>;
  fifth?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['String']['input'];
  fourth?: InputMaybe<Scalars['String']['input']>;
  second?: InputMaybe<Scalars['String']['input']>;
  seventh?: InputMaybe<Scalars['String']['input']>;
  sixth?: InputMaybe<Scalars['String']['input']>;
  third?: InputMaybe<Scalars['String']['input']>;
};

export type SDK_Frame = {
  __typename?: 'Frame';
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
};

export type SDK_FrameInput = {
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
};

export type SDK_GetFiles = {
  __typename?: 'GetFiles';
  files: Array<SDK_QpFile>;
};

export type SDK_GetStacksResult = SDK_StackCfKeys | SDK_StackErrorMessage;

export type SDK_Grid = {
  __typename?: 'Grid';
  align: SDK_Align;
  columnGap: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  rowGap: Scalars['Float']['output'];
  singleColumnInPortrait: Scalars['Boolean']['output'];
  startingPoint: SDK_StartingPoint;
};

export type SDK_GridInput = {
  align: SDK_Align;
  columnGap: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  rowGap?: InputMaybe<Scalars['Float']['input']>;
  singleColumnInPortrait: Scalars['Boolean']['input'];
  startingPoint: SDK_StartingPoint;
};

export type SDK_ImageFilter = {
  __typename?: 'ImageFilter';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  cornerRadius: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
};

export type SDK_ImageFilterInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  cornerRadius: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
};

export type SDK_ImageInput = {
  altText: Scalars['String']['input'];
  url: Scalars['String']['input'];
  userDefinedName: Scalars['String']['input'];
};

export type SDK_Line = {
  __typename?: 'Line';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  weight: SDK_FontWeight;
};

export type SDK_LineInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  weight: SDK_FontWeight;
};

export type SDK_Link = {
  __typename?: 'Link';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  visited?: Maybe<SDK_ColorChoice>;
  weight: SDK_FontWeight;
};

export type SDK_LinkInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  visited?: InputMaybe<SDK_ColorChoice>;
  weight: SDK_FontWeight;
};

export type SDK_List = {
  __typename?: 'List';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  weight: SDK_FontWeight;
};

export type SDK_ListInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  weight: SDK_FontWeight;
};

export type SDK_MailerResponse = {
  __typename?: 'MailerResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SDK_Mutation = {
  __typename?: 'Mutation';
  deleteFile?: Maybe<SDK_FileUpdateResponse>;
  deleteStack?: Maybe<SDK_StackUpdateResponse>;
  generateAiImage?: Maybe<SDK_FileResult>;
  generateLayout?: Maybe<SDK_AiChatResult>;
  importPublicDomainImage?: Maybe<SDK_FileResult>;
  publishStack?: Maybe<SDK_StackUpdateResponse>;
  renameStack?: Maybe<SDK_StackUpdateResponse>;
  setFilterPublish?: Maybe<SDK_FilterUpdateResponse>;
  unPublishStack?: Maybe<SDK_StackUpdateResponse>;
  updateFile?: Maybe<SDK_FileUpdateResponse>;
  updateFilter?: Maybe<SDK_FilterUpdateResponse>;
  updateStack?: Maybe<SDK_StackUpdateResponse>;
  writeUserRecord?: Maybe<SDK_FileUpdateResponse>;
};


export type SDK_MutationDeleteFileArgs = {
  fileId: Scalars['String']['input'];
  jwt: Scalars['String']['input'];
};


export type SDK_MutationDeleteStackArgs = {
  jwt: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  stackCfKey: Scalars['String']['input'];
};


export type SDK_MutationGenerateAiImageArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  jwt: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
  useContext?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SDK_MutationGenerateLayoutArgs = {
  availableImages?: InputMaybe<Scalars['String']['input']>;
  chatHistory?: InputMaybe<Array<SDK_AiChatMessageInput>>;
  code?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
};


export type SDK_MutationImportPublicDomainImageArgs = {
  fullImageUrl: Scalars['String']['input'];
  jwt: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  source: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type SDK_MutationPublishStackArgs = {
  jwt: Scalars['String']['input'];
  stackCfKey: Scalars['String']['input'];
};


export type SDK_MutationRenameStackArgs = {
  jwt: Scalars['String']['input'];
  newStackCfKey: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  stackCfKey: Scalars['String']['input'];
};


export type SDK_MutationSetFilterPublishArgs = {
  filterName: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  publish: Scalars['Boolean']['input'];
};


export type SDK_MutationUnPublishStackArgs = {
  jwt: Scalars['String']['input'];
  stackCfKey: Scalars['String']['input'];
};


export type SDK_MutationUpdateFileArgs = {
  altText: Scalars['String']['input'];
  bytes?: InputMaybe<Scalars['Float']['input']>;
  cloudFlareName: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  id: Scalars['String']['input'];
  jwt: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
  uploadedOn: Scalars['Float']['input'];
  url: Scalars['String']['input'];
  userDefinedName: Scalars['String']['input'];
};


export type SDK_MutationUpdateFilterArgs = {
  align: SDK_Align;
  audioPlayer: SDK_AudioPlayerInput;
  autospace: Scalars['Boolean']['input'];
  background: Scalars['String']['input'];
  blank: SDK_BlankInput;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  box: SDK_BoxInput;
  bullet: SDK_BulletInput;
  button: SDK_ButtonInput;
  caption: SDK_CaptionInput;
  cell: SDK_CellInput;
  chart: SDK_ChartFilterInput;
  color: Scalars['String']['input'];
  colors: SDK_ColorsInput;
  columnTitle: SDK_ColumnTitleInput;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  filterName: Scalars['String']['input'];
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontSizes: SDK_FontSizesInput;
  fontStyle: SDK_FontStyle;
  fonts: SDK_FontsInput;
  frame: SDK_FrameInput;
  grid: SDK_GridInput;
  image: SDK_ImageFilterInput;
  line: SDK_LineInput;
  lineHeightMultiplier: Scalars['Float']['input'];
  link: SDK_LinkInput;
  list: SDK_ListInput;
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  ownerName: Scalars['String']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  paragraph: SDK_ParagraphInput;
  publish: Scalars['Boolean']['input'];
  read: SDK_ReadInput;
  startingPoint: SDK_StartingPoint;
  stickyFooter: SDK_StickyFooterInput;
  stickyHeader: SDK_StickyHeaderInput;
  subtitle: SDK_SubTitleInput;
  supertitle: SDK_SuperTitleInput;
  table: SDK_TableInput;
  tableCell: SDK_TableCellInput;
  title: SDK_TitleInput;
  weight: SDK_FontWeight;
};


export type SDK_MutationUpdateStackArgs = {
  audioFiles?: InputMaybe<Array<SDK_AudioFileInput>>;
  code?: InputMaybe<Scalars['String']['input']>;
  created: Scalars['Float']['input'];
  dataFiles?: InputMaybe<Array<SDK_DataFileInput>>;
  filters: Array<Scalars['String']['input']>;
  images: Array<SDK_ImageInput>;
  jwt: Scalars['String']['input'];
  navigationType?: InputMaybe<Scalars['String']['input']>;
  ownerName: Scalars['String']['input'];
  publish: Scalars['Boolean']['input'];
  stackCfKey: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
  storyName?: InputMaybe<Scalars['String']['input']>;
  updated: Scalars['Float']['input'];
};


export type SDK_MutationWriteUserRecordArgs = {
  created: Scalars['Float']['input'];
  id: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
  stack: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SDK_Paragraph = {
  __typename?: 'Paragraph';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  weight: SDK_FontWeight;
};

export type SDK_ParagraphInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  weight: SDK_FontWeight;
};

export type SDK_PublicDomainImageResult = {
  __typename?: 'PublicDomainImageResult';
  fullImageUrl: Scalars['String']['output'];
  license: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourcePageUrl: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SDK_QpFile = {
  __typename?: 'QpFile';
  altText: Scalars['String']['output'];
  cloudFlareName: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ownerName: Scalars['String']['output'];
  stackId: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  uploadedOn: Scalars['Float']['output'];
  url: Scalars['String']['output'];
  userDefinedName: Scalars['String']['output'];
};

export type SDK_Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  _unused?: Maybe<Scalars['Boolean']['output']>;
  getFile: SDK_FileResult;
  getFiles?: Maybe<SDK_GetFiles>;
  getFilter: SDK_Filter;
  getFilterNames: Array<SDK_FilterName>;
  getFont: SDK_Font;
  getStack?: Maybe<SDK_StackResult>;
  getStackCfKeys?: Maybe<SDK_GetStacksResult>;
  getStackIsPublished: Scalars['Boolean']['output'];
  hello?: Maybe<Scalars['String']['output']>;
  searchPublicDomainImages?: Maybe<SDK_SearchResults>;
  sendMail: SDK_MailerResponse;
  viewFile: SDK_ViewFile;
  viewStack: SDK_ViewStack;
};


export type SDK_QueryGetFileArgs = {
  id: Scalars['String']['input'];
  jwt: Scalars['String']['input'];
};


export type SDK_QueryGetFilesArgs = {
  jwt: Scalars['String']['input'];
};


export type SDK_QueryGetFilterArgs = {
  filterName: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
};


export type SDK_QueryGetFilterNamesArgs = {
  jwt: Scalars['String']['input'];
};


export type SDK_QueryGetFontArgs = {
  fontName: Scalars['String']['input'];
};


export type SDK_QueryGetStackArgs = {
  jwt: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  stackCfKey: Scalars['String']['input'];
};


export type SDK_QueryGetStackCfKeysArgs = {
  jwt: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
};


export type SDK_QueryGetStackIsPublishedArgs = {
  jwt: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  stackCfKey: Scalars['String']['input'];
};


export type SDK_QuerySearchPublicDomainImagesArgs = {
  jwt: Scalars['String']['input'];
  query: Scalars['String']['input'];
};


export type SDK_QuerySendMailArgs = {
  emailStackCfKey: Scalars['String']['input'];
  emailTo: Scalars['String']['input'];
  resendId: Scalars['String']['input'];
};


export type SDK_QueryViewFileArgs = {
  id: Scalars['String']['input'];
};


export type SDK_QueryViewStackArgs = {
  stackCfKey: Scalars['String']['input'];
};

export type SDK_Read = {
  __typename?: 'Read';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  weight: SDK_FontWeight;
};

export type SDK_ReadInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  weight: SDK_FontWeight;
};

export type SDK_SearchResults = {
  __typename?: 'SearchResults';
  results: Array<SDK_PublicDomainImageResult>;
};

export type SDK_Stack = {
  __typename?: 'Stack';
  audioFiles: Array<Maybe<SDK_ViewFile>>;
  code?: Maybe<Scalars['String']['output']>;
  created: Scalars['Float']['output'];
  dataFiles: Array<Maybe<SDK_ViewFile>>;
  filters: Array<Maybe<Scalars['String']['output']>>;
  images: Array<Maybe<SDK_ViewFile>>;
  ownerName: Scalars['String']['output'];
  publish: Scalars['Boolean']['output'];
  stackCfKey: Scalars['String']['output'];
  stackId: Scalars['String']['output'];
  storyName?: Maybe<Scalars['String']['output']>;
  updated: Scalars['Float']['output'];
};

export type SDK_StackCfKey = {
  __typename?: 'StackCfKey';
  created: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  updated: Scalars['Float']['output'];
};

export type SDK_StackCfKeys = {
  __typename?: 'StackCfKeys';
  stackCfKeys: Array<SDK_StackCfKey>;
};

export type SDK_StackErrorMessage = {
  __typename?: 'StackErrorMessage';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SDK_StackResult = SDK_Stack | SDK_StackErrorMessage;

export type SDK_StackUpdateResponse = {
  __typename?: 'StackUpdateResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum SDK_StartingPoint {
  BottomUp = 'bottomUp',
  MiddleOut = 'middleOut',
  TopDown = 'topDown',
  Unset = 'unset'
}

export type SDK_StickyFooter = {
  __typename?: 'StickyFooter';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  cornerRadius: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  startingPoint: SDK_StartingPoint;
};

export type SDK_StickyFooterInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  cornerRadius: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  startingPoint: SDK_StartingPoint;
};

export type SDK_StickyHeader = {
  __typename?: 'StickyHeader';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  cornerRadius: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  startingPoint: SDK_StartingPoint;
};

export type SDK_StickyHeaderInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  cornerRadius: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  startingPoint: SDK_StartingPoint;
};

export type SDK_SubTitle = {
  __typename?: 'SubTitle';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  weight: SDK_FontWeight;
};

export type SDK_SubTitleInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  weight: SDK_FontWeight;
};

export type SDK_SuperTitle = {
  __typename?: 'SuperTitle';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  weight: SDK_FontWeight;
};

export type SDK_SuperTitleInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  weight: SDK_FontWeight;
};

export type SDK_Table = {
  __typename?: 'Table';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  color: SDK_ColorChoice;
  columnGap: Scalars['Float']['output'];
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  rowGap: Scalars['Float']['output'];
  singleColumnInPortrait: Scalars['Boolean']['output'];
  startingPoint: SDK_StartingPoint;
  weight: SDK_FontWeight;
};

export type SDK_TableCell = {
  __typename?: 'TableCell';
  align: SDK_Align;
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  startingPoint: SDK_StartingPoint;
};

export type SDK_TableCellInput = {
  align: SDK_Align;
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  startingPoint: SDK_StartingPoint;
};

export type SDK_TableInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  color: SDK_ColorChoice;
  columnGap: Scalars['Float']['input'];
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  rowGap?: InputMaybe<Scalars['Float']['input']>;
  singleColumnInPortrait: Scalars['Boolean']['input'];
  startingPoint: SDK_StartingPoint;
  weight: SDK_FontWeight;
};

export enum SDK_TextDecoration {
  Overline = 'overline',
  Strikethrough = 'strikethrough',
  Underline = 'underline',
  Unset = 'unset'
}

export type SDK_Title = {
  __typename?: 'Title';
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['output'];
  borderBlockStart: Scalars['Float']['output'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['output'];
  borderInlineStart: Scalars['Float']['output'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['output'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['output'];
  marginBottomMultiplier: Scalars['Float']['output'];
  marginTopMultiplier: Scalars['Float']['output'];
  opacity: Scalars['Float']['output'];
  paddingBlockEnd: Scalars['Float']['output'];
  paddingBlockStart: Scalars['Float']['output'];
  paddingInlineEnd: Scalars['Float']['output'];
  paddingInlineStart: Scalars['Float']['output'];
  weight: SDK_FontWeight;
};

export type SDK_TitleInput = {
  align: SDK_Align;
  background: SDK_ColorChoice;
  borderBlockEnd: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  color: SDK_ColorChoice;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  font: SDK_FontChoice;
  fontSize: SDK_FontSizeChoice;
  fontStyle: SDK_FontStyle;
  lineHeight: Scalars['Float']['input'];
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  opacity: Scalars['Float']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  weight: SDK_FontWeight;
};

export type SDK_ViewFile = {
  __typename?: 'ViewFile';
  altText: Scalars['String']['output'];
  url: Scalars['String']['output'];
  userDefinedName: Scalars['String']['output'];
};

export type SDK_ViewStack = {
  __typename?: 'ViewStack';
  audioFiles: Array<Maybe<SDK_ViewFile>>;
  code?: Maybe<Scalars['String']['output']>;
  dataFiles: Array<Maybe<SDK_ViewFile>>;
  filters: Array<Maybe<Scalars['String']['output']>>;
  hideAttribution?: Maybe<Scalars['Boolean']['output']>;
  images: Array<Maybe<SDK_ViewFile>>;
  navigationType?: Maybe<Scalars['String']['output']>;
  ownerName: Scalars['String']['output'];
  publish?: Maybe<Scalars['Boolean']['output']>;
  stackCfKey: Scalars['String']['output'];
  stackId: Scalars['String']['output'];
  storyName?: Maybe<Scalars['String']['output']>;
};

export type SDK_GenerateAiImageMutationVariables = Exact<{
  prompt: Scalars['String']['input'];
  jwt: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
  useContext?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type SDK_GenerateAiImageMutation = { __typename?: 'Mutation', generateAiImage?: { __typename: 'FileErrorMessage', success: boolean, message: string } | { __typename: 'QpFile', id: string, url: string, userDefinedName: string, altText: string } | null };

export type SDK_GetFileQueryVariables = Exact<{
  id: Scalars['String']['input'];
  jwt: Scalars['String']['input'];
}>;


export type SDK_GetFileQuery = { __typename?: 'Query', getFile: { __typename: 'FileErrorMessage', success: boolean, message: string } | { __typename: 'QpFile', altText: string, cloudFlareName: string, fileName: string, fileType: string, id: string, ownerName: string, stackId: string, tags: Array<string>, uploadedOn: number, url: string, userDefinedName: string } };

export type SDK_GetFilesQueryVariables = Exact<{
  jwt: Scalars['String']['input'];
}>;


export type SDK_GetFilesQuery = { __typename?: 'Query', getFiles?: { __typename?: 'GetFiles', files: Array<{ __typename?: 'QpFile', altText: string, cloudFlareName: string, fileName: string, fileType: string, id: string, ownerName: string, stackId: string, tags: Array<string>, uploadedOn: number, url: string, userDefinedName: string }> } | null };

export type SDK_GetFilterNamesQueryVariables = Exact<{
  jwt: Scalars['String']['input'];
}>;


export type SDK_GetFilterNamesQuery = { __typename?: 'Query', getFilterNames: Array<{ __typename?: 'FilterName', filterName?: string | null, ownerName?: string | null }> };

export type SDK_GetFilterQueryVariables = Exact<{
  ownerName: Scalars['String']['input'];
  filterName: Scalars['String']['input'];
}>;


export type SDK_GetFilterQuery = { __typename?: 'Query', getFilter: { __typename?: 'Filter', align: SDK_Align, autospace: boolean, background: string, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, color: string, cornerRadius: number, decoration: SDK_TextDecoration, filterName: string, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeightMultiplier: number, marginBottomMultiplier: number, marginTopMultiplier: number, ownerName: string, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number, publish: boolean, startingPoint: SDK_StartingPoint, weight: SDK_FontWeight, audioPlayer: { __typename?: 'AudioPlayer', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, color: SDK_ColorChoice, cornerRadius: number, decoration: SDK_TextDecoration, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeight: number, marginBottomMultiplier: number, marginTopMultiplier: number, opacity: number, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number, weight: SDK_FontWeight }, blank: { __typename?: 'Blank', fontSize: SDK_FontSizeChoice, leading: number }, box: { __typename?: 'Box', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, color: SDK_ColorChoice, cornerRadius: number, decoration: SDK_TextDecoration, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeight: number, marginBottomMultiplier: number, marginTopMultiplier: number, opacity: number, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number, weight: SDK_FontWeight }, bullet: { __typename?: 'Bullet', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, color: SDK_ColorChoice, cornerRadius: number, decoration: SDK_TextDecoration, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeight: number, marginBottomMultiplier: number, marginTopMultiplier: number, opacity: number, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number, space?: number | null, markerColor?: SDK_ColorChoice | null, weight: SDK_FontWeight }, button: { __typename?: 'Button', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, color: SDK_ColorChoice, cornerRadius: number, decoration: SDK_TextDecoration, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeight: number, marginBottomMultiplier: number, marginTopMultiplier: number, opacity: number, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number, weight: SDK_FontWeight }, caption: { __typename?: 'Caption', align: SDK_Align, backdropOpacity: number, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, color: SDK_ColorChoice, cornerRadius: number, decoration: SDK_TextDecoration, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeight: number, marginBottomMultiplier: number, marginTopMultiplier: number, opacity: number, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number, weight: SDK_FontWeight }, cell: { __typename?: 'Cell', align: SDK_Align, startingPoint: SDK_StartingPoint, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number }, tableCell: { __typename?: 'TableCell', align: SDK_Align, startingPoint: SDK_StartingPoint, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number }, colors: { __typename?: 'Colors', first: string, second: string, third?: string | null, eighth?: string | null, fourth?: string | null, fifth?: string | null, sixth?: string | null, seventh?: string | null }, fonts: { __typename?: 'Fonts', first: string, second?: string | null, third?: string | null, eighth?: string | null, fourth?: string | null, fifth?: string | null, sixth?: string | null, seventh?: string | null }, fontSizes: { __typename?: 'FontSizes', first: number, second?: number | null, third?: number | null, eighth?: number | null, fourth?: number | null, fifth?: number | null, sixth?: number | null, seventh?: number | null }, frame: { __typename?: 'Frame', paddingBlockEnd: number, paddingBlockStart: number, paddingInlineEnd: number, paddingInlineStart: number }, grid: { __typename?: 'Grid', align: SDK_Align, columnGap: number, paddingBlockEnd: number, paddingBlockStart: number, paddingInlineEnd: number, paddingInlineStart: number, rowGap: number, singleColumnInPortrait: boolean, startingPoint: SDK_StartingPoint }, image: { __typename?: 'ImageFilter', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, cornerRadius: number, marginBottomMultiplier: number, marginTopMultiplier: number, opacity: number, paddingBlockEnd: number, paddingBlockStart: number, paddingInlineEnd: number, paddingInlineStart: number }, line: { __typename?: 'Line', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, color: SDK_ColorChoice, cornerRadius: number, decoration: SDK_TextDecoration, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeight: number, marginBottomMultiplier: number, marginTopMultiplier: number, opacity: number, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number, weight: SDK_FontWeight }, link: { __typename?: 'Link', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, color: SDK_ColorChoice, cornerRadius: number, decoration: SDK_TextDecoration, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeight: number, marginBottomMultiplier: number, marginTopMultiplier: number, opacity: number, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number, visited?: SDK_ColorChoice | null, weight: SDK_FontWeight }, list: { __typename?: 'List', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, color: SDK_ColorChoice, cornerRadius: number, decoration: SDK_TextDecoration, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeight: number, marginBottomMultiplier: number, marginTopMultiplier: number, opacity: number, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number, weight: SDK_FontWeight }, paragraph: { __typename?: 'Paragraph', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, color: SDK_ColorChoice, cornerRadius: number, decoration: SDK_TextDecoration, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeight: number, marginBottomMultiplier: number, marginTopMultiplier: number, opacity: number, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number, weight: SDK_FontWeight }, columnTitle: { __typename?: 'ColumnTitle', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, color: SDK_ColorChoice, cornerRadius: number, decoration: SDK_TextDecoration, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeight: number, marginBottomMultiplier: number, marginTopMultiplier: number, opacity: number, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number, weight: SDK_FontWeight }, read: { __typename?: 'Read', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, color: SDK_ColorChoice, cornerRadius: number, decoration: SDK_TextDecoration, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeight: number, marginBottomMultiplier: number, marginTopMultiplier: number, opacity: number, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number, weight: SDK_FontWeight }, stickyFooter: { __typename?: 'StickyFooter', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, cornerRadius: number, marginTopMultiplier: number, marginBottomMultiplier: number, opacity: number, startingPoint: SDK_StartingPoint }, stickyHeader: { __typename?: 'StickyHeader', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, cornerRadius: number, marginTopMultiplier: number, marginBottomMultiplier: number, opacity: number, startingPoint: SDK_StartingPoint }, subtitle: { __typename?: 'SubTitle', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, color: SDK_ColorChoice, cornerRadius: number, decoration: SDK_TextDecoration, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeight: number, marginBottomMultiplier: number, marginTopMultiplier: number, opacity: number, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number, weight: SDK_FontWeight }, supertitle: { __typename?: 'SuperTitle', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, color: SDK_ColorChoice, cornerRadius: number, decoration: SDK_TextDecoration, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeight: number, marginBottomMultiplier: number, marginTopMultiplier: number, opacity: number, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number, weight: SDK_FontWeight }, title: { __typename?: 'Title', align: SDK_Align, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, color: SDK_ColorChoice, cornerRadius: number, decoration: SDK_TextDecoration, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeight: number, marginBottomMultiplier: number, marginTopMultiplier: number, opacity: number, paddingBlockEnd: number, paddingInlineStart: number, paddingInlineEnd: number, paddingBlockStart: number, weight: SDK_FontWeight }, table: { __typename?: 'Table', align: SDK_Align, columnGap: number, paddingBlockEnd: number, paddingBlockStart: number, paddingInlineEnd: number, paddingInlineStart: number, rowGap: number, singleColumnInPortrait: boolean, startingPoint: SDK_StartingPoint, color: SDK_ColorChoice, decoration: SDK_TextDecoration, font: SDK_FontChoice, fontSize: SDK_FontSizeChoice, fontStyle: SDK_FontStyle, lineHeight: number, weight: SDK_FontWeight, background: SDK_ColorChoice, borderBlockEnd: number, borderInlineEnd: number, borderInlineStart: number, borderBlockStart: number, borderColor: SDK_ColorChoice, cornerRadius: number, marginTopMultiplier: number, marginBottomMultiplier: number, opacity: number }, chart: { __typename?: 'ChartFilter', colors: Array<string> } } };

export type SDK_GetFontQueryVariables = Exact<{
  fontName: Scalars['String']['input'];
}>;


export type SDK_GetFontQuery = { __typename?: 'Query', getFont: { __typename?: 'Font', fontData?: string | null, fontName: string } };

export type SDK_GetStackQueryVariables = Exact<{
  ownerName: Scalars['String']['input'];
  stackCfKey: Scalars['String']['input'];
  jwt: Scalars['String']['input'];
}>;


export type SDK_GetStackQuery = { __typename?: 'Query', getStack?: { __typename: 'Stack', code?: string | null, created: number, filters: Array<string | null>, ownerName: string, publish: boolean, stackCfKey: string, stackId: string, updated: number, audioFiles: Array<{ __typename?: 'ViewFile', altText: string, url: string, userDefinedName: string } | null>, dataFiles: Array<{ __typename?: 'ViewFile', altText: string, url: string, userDefinedName: string } | null>, images: Array<{ __typename?: 'ViewFile', altText: string, url: string, userDefinedName: string } | null> } | { __typename: 'StackErrorMessage', success: boolean, message: string } | null };

export type SDK_GetStackCfKeysQueryVariables = Exact<{
  ownerName: Scalars['String']['input'];
  jwt: Scalars['String']['input'];
}>;


export type SDK_GetStackCfKeysQuery = { __typename?: 'Query', getStackCfKeys?: { __typename: 'StackCfKeys', stackCfKeys: Array<{ __typename?: 'StackCfKey', key: string, created: number, updated: number }> } | { __typename: 'StackErrorMessage', success: boolean, message: string } | null };

export type SDK_GetStackIsPublishedQueryVariables = Exact<{
  ownerName: Scalars['String']['input'];
  stackCfKey: Scalars['String']['input'];
  jwt: Scalars['String']['input'];
}>;


export type SDK_GetStackIsPublishedQuery = { __typename?: 'Query', getStackIsPublished: boolean };

export type SDK_ImportPublicDomainImageMutationVariables = Exact<{
  fullImageUrl: Scalars['String']['input'];
  title: Scalars['String']['input'];
  source: Scalars['String']['input'];
  jwt: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
}>;


export type SDK_ImportPublicDomainImageMutation = { __typename?: 'Mutation', importPublicDomainImage?: { __typename: 'FileErrorMessage', success: boolean, message: string } | { __typename: 'QpFile', id: string, url: string, userDefinedName: string, altText: string } | null };

export type SDK_GenerateLayoutMutationVariables = Exact<{
  prompt?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  availableImages?: InputMaybe<Scalars['String']['input']>;
  chatHistory?: InputMaybe<Array<SDK_AiChatMessageInput> | SDK_AiChatMessageInput>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type SDK_GenerateLayoutMutation = { __typename?: 'Mutation', generateLayout?: { __typename: 'AiChatResponse', jadle: string, explanation: string } | { __typename: 'StackErrorMessage', success: boolean, message: string } | null };

export type SDK_SendMailQueryVariables = Exact<{
  emailTo: Scalars['String']['input'];
  emailStackCfKey: Scalars['String']['input'];
  resendId: Scalars['String']['input'];
}>;


export type SDK_SendMailQuery = { __typename?: 'Query', sendMail: { __typename?: 'MailerResponse', success: boolean, message?: string | null } };

export type SDK_SearchPublicDomainImagesQueryVariables = Exact<{
  query: Scalars['String']['input'];
  jwt: Scalars['String']['input'];
}>;


export type SDK_SearchPublicDomainImagesQuery = { __typename?: 'Query', searchPublicDomainImages?: { __typename?: 'SearchResults', results: Array<{ __typename?: 'PublicDomainImageResult', thumbnailUrl: string, fullImageUrl: string, title: string, source: string, sourcePageUrl: string, license: string }> } | null };

export type SDK_UpdateFileMutationVariables = Exact<{
  altText: Scalars['String']['input'];
  cloudFlareName: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  id: Scalars['String']['input'];
  jwt: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
  uploadedOn: Scalars['Float']['input'];
  url: Scalars['String']['input'];
  userDefinedName: Scalars['String']['input'];
  bytes?: InputMaybe<Scalars['Float']['input']>;
}>;


export type SDK_UpdateFileMutation = { __typename?: 'Mutation', updateFile?: { __typename?: 'FileUpdateResponse', success: boolean, message?: string | null } | null };

export type SDK_DeleteFileMutationVariables = Exact<{
  fileId: Scalars['String']['input'];
  jwt: Scalars['String']['input'];
}>;


export type SDK_DeleteFileMutation = { __typename?: 'Mutation', deleteFile?: { __typename?: 'FileUpdateResponse', success: boolean, message?: string | null } | null };

export type SDK_UpdateFilterMutationVariables = Exact<{
  align: SDK_Align;
  autospace: Scalars['Boolean']['input'];
  audioPlayer: SDK_AudioPlayerInput;
  background: Scalars['String']['input'];
  borderBlockEnd: Scalars['Float']['input'];
  borderInlineEnd: Scalars['Float']['input'];
  borderInlineStart: Scalars['Float']['input'];
  borderBlockStart: Scalars['Float']['input'];
  borderColor: SDK_ColorChoice;
  blank: SDK_BlankInput;
  box: SDK_BoxInput;
  bullet: SDK_BulletInput;
  button: SDK_ButtonInput;
  caption: SDK_CaptionInput;
  cell: SDK_CellInput;
  tableCell: SDK_TableCellInput;
  color: Scalars['String']['input'];
  colors: SDK_ColorsInput;
  cornerRadius: Scalars['Float']['input'];
  decoration: SDK_TextDecoration;
  filterName: Scalars['String']['input'];
  font: SDK_FontChoice;
  fonts: SDK_FontsInput;
  fontSize: SDK_FontSizeChoice;
  fontSizes: SDK_FontSizesInput;
  fontStyle: SDK_FontStyle;
  frame: SDK_FrameInput;
  grid: SDK_GridInput;
  image: SDK_ImageFilterInput;
  line: SDK_LineInput;
  lineHeightMultiplier: Scalars['Float']['input'];
  link: SDK_LinkInput;
  list: SDK_ListInput;
  marginBottomMultiplier: Scalars['Float']['input'];
  marginTopMultiplier: Scalars['Float']['input'];
  ownerName: Scalars['String']['input'];
  paddingBlockEnd: Scalars['Float']['input'];
  paddingBlockStart: Scalars['Float']['input'];
  paddingInlineEnd: Scalars['Float']['input'];
  paddingInlineStart: Scalars['Float']['input'];
  paragraph: SDK_ParagraphInput;
  publish: Scalars['Boolean']['input'];
  read: SDK_ReadInput;
  stickyFooter: SDK_StickyFooterInput;
  stickyHeader: SDK_StickyHeaderInput;
  startingPoint: SDK_StartingPoint;
  subtitle: SDK_SubTitleInput;
  supertitle: SDK_SuperTitleInput;
  title: SDK_TitleInput;
  weight: SDK_FontWeight;
  columnTitle: SDK_ColumnTitleInput;
  table: SDK_TableInput;
  chart: SDK_ChartFilterInput;
}>;


export type SDK_UpdateFilterMutation = { __typename?: 'Mutation', updateFilter?: { __typename?: 'FilterUpdateResponse', success: boolean, message?: string | null } | null };

export type SDK_DeleteStackMutationVariables = Exact<{
  jwt: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  stackCfKey: Scalars['String']['input'];
}>;


export type SDK_DeleteStackMutation = { __typename?: 'Mutation', deleteStack?: { __typename?: 'StackUpdateResponse', success: boolean, message?: string | null } | null };

export type SDK_UpdateStackMutationVariables = Exact<{
  audioFiles: Array<SDK_AudioFileInput> | SDK_AudioFileInput;
  code?: InputMaybe<Scalars['String']['input']>;
  created: Scalars['Float']['input'];
  dataFiles: Array<SDK_DataFileInput> | SDK_DataFileInput;
  filters: Array<Scalars['String']['input']> | Scalars['String']['input'];
  images: Array<SDK_ImageInput> | SDK_ImageInput;
  jwt: Scalars['String']['input'];
  navigationType: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  publish: Scalars['Boolean']['input'];
  stackCfKey: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
  storyName?: InputMaybe<Scalars['String']['input']>;
  updated: Scalars['Float']['input'];
}>;


export type SDK_UpdateStackMutation = { __typename?: 'Mutation', updateStack?: { __typename?: 'StackUpdateResponse', success: boolean, message?: string | null } | null };

export type SDK_RenameStackMutationVariables = Exact<{
  jwt: Scalars['String']['input'];
  newStackCfKey: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  stackCfKey: Scalars['String']['input'];
}>;


export type SDK_RenameStackMutation = { __typename?: 'Mutation', renameStack?: { __typename?: 'StackUpdateResponse', success: boolean, message?: string | null } | null };

export type SDK_PublishStackMutationVariables = Exact<{
  jwt: Scalars['String']['input'];
  stackCfKey: Scalars['String']['input'];
}>;


export type SDK_PublishStackMutation = { __typename?: 'Mutation', publishStack?: { __typename?: 'StackUpdateResponse', success: boolean, message?: string | null } | null };

export type SDK_UnPublishStackMutationVariables = Exact<{
  jwt: Scalars['String']['input'];
  stackCfKey: Scalars['String']['input'];
}>;


export type SDK_UnPublishStackMutation = { __typename?: 'Mutation', unPublishStack?: { __typename?: 'StackUpdateResponse', success: boolean, message?: string | null } | null };

export type SDK_WriteUserRecordMutationVariables = Exact<{
  id: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
  stack: Scalars['String']['input'];
  stackId: Scalars['String']['input'];
  value: Scalars['String']['input'];
  created: Scalars['Float']['input'];
}>;


export type SDK_WriteUserRecordMutation = { __typename?: 'Mutation', writeUserRecord?: { __typename?: 'FileUpdateResponse', success: boolean, message?: string | null } | null };

export type SDK_ViewFileQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SDK_ViewFileQuery = { __typename?: 'Query', viewFile: { __typename?: 'ViewFile', altText: string, url: string, userDefinedName: string } };

export type SDK_ViewStackQueryVariables = Exact<{
  stackCfKey: Scalars['String']['input'];
}>;


export type SDK_ViewStackQuery = { __typename?: 'Query', viewStack: { __typename?: 'ViewStack', code?: string | null, filters: Array<string | null>, stackId: string, hideAttribution?: boolean | null, audioFiles: Array<{ __typename?: 'ViewFile', userDefinedName: string, url: string, altText: string } | null>, dataFiles: Array<{ __typename?: 'ViewFile', userDefinedName: string, url: string, altText: string } | null>, images: Array<{ __typename?: 'ViewFile', userDefinedName: string, url: string, altText: string } | null> } };


export const GenerateAiImageDocument = `
    mutation GenerateAiImage($prompt: String!, $jwt: String!, $ownerName: String!, $stackId: String!, $useContext: Boolean, $code: String, $filter: String) {
  generateAiImage(
    prompt: $prompt
    jwt: $jwt
    ownerName: $ownerName
    stackId: $stackId
    useContext: $useContext
    code: $code
    filter: $filter
  ) {
    ... on QpFile {
      __typename
      id
      url
      userDefinedName
      altText
    }
    ... on FileErrorMessage {
      __typename
      success
      message
    }
  }
}
    `;
export const GetFileDocument = `
    query GetFile($id: String!, $jwt: String!) {
  getFile(id: $id, jwt: $jwt) {
    ... on QpFile {
      __typename
      altText
      cloudFlareName
      fileName
      fileType
      id
      ownerName
      stackId
      tags
      uploadedOn
      url
      userDefinedName
    }
    ... on FileErrorMessage {
      __typename
      success
      message
    }
  }
}
    `;
export const GetFilesDocument = `
    query GetFiles($jwt: String!) {
  getFiles(jwt: $jwt) {
    files {
      altText
      cloudFlareName
      fileName
      fileType
      id
      ownerName
      stackId
      tags
      uploadedOn
      url
      userDefinedName
    }
  }
}
    `;
export const GetFilterNamesDocument = `
    query GetFilterNames($jwt: String!) {
  getFilterNames(jwt: $jwt) {
    filterName
    ownerName
  }
}
    `;
export const GetFilterDocument = `
    query GetFilter($ownerName: String!, $filterName: String!) {
  getFilter(ownerName: $ownerName, filterName: $filterName) {
    align
    autospace
    background
    borderBlockEnd
    borderInlineEnd
    borderInlineStart
    borderBlockStart
    borderColor
    color
    cornerRadius
    decoration
    filterName
    font
    fontSize
    fontStyle
    lineHeightMultiplier
    marginBottomMultiplier
    marginTopMultiplier
    ownerName
    paddingBlockEnd
    paddingInlineStart
    paddingInlineEnd
    paddingBlockStart
    publish
    startingPoint
    weight
    audioPlayer {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    blank {
      fontSize
      leading
    }
    box {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    bullet {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      space
      markerColor
      weight
    }
    button {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    caption {
      align
      backdropOpacity
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    cell {
      align
      startingPoint
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
    }
    tableCell {
      align
      startingPoint
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
    }
    colors {
      first
      second
      third
      eighth
      fourth
      fifth
      sixth
      seventh
    }
    fonts {
      first
      second
      third
      eighth
      fourth
      fifth
      sixth
      seventh
    }
    fontSizes {
      first
      second
      third
      eighth
      fourth
      fifth
      sixth
      seventh
    }
    frame {
      paddingBlockEnd
      paddingBlockStart
      paddingInlineEnd
      paddingInlineStart
    }
    grid {
      align
      columnGap
      paddingBlockEnd
      paddingBlockStart
      paddingInlineEnd
      paddingInlineStart
      rowGap
      singleColumnInPortrait
      startingPoint
    }
    image {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      cornerRadius
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingBlockStart
      paddingInlineEnd
      paddingInlineStart
    }
    line {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    link {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      visited
      weight
    }
    list {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    paragraph {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    columnTitle {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    read {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    stickyFooter {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      cornerRadius
      marginTopMultiplier
      marginBottomMultiplier
      opacity
      startingPoint
    }
    stickyHeader {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      cornerRadius
      marginTopMultiplier
      marginBottomMultiplier
      opacity
      startingPoint
    }
    subtitle {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    supertitle {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    title {
      align
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      color
      cornerRadius
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      marginBottomMultiplier
      marginTopMultiplier
      opacity
      paddingBlockEnd
      paddingInlineStart
      paddingInlineEnd
      paddingBlockStart
      weight
    }
    table {
      align
      columnGap
      paddingBlockEnd
      paddingBlockStart
      paddingInlineEnd
      paddingInlineStart
      rowGap
      singleColumnInPortrait
      startingPoint
      color
      decoration
      font
      fontSize
      fontStyle
      lineHeight
      weight
      background
      borderBlockEnd
      borderInlineEnd
      borderInlineStart
      borderBlockStart
      borderColor
      cornerRadius
      marginTopMultiplier
      marginBottomMultiplier
      opacity
    }
    chart {
      colors
    }
  }
}
    `;
export const GetFontDocument = `
    query GetFont($fontName: String!) {
  getFont(fontName: $fontName) {
    fontData
    fontName
  }
}
    `;
export const GetStackDocument = `
    query GetStack($ownerName: String!, $stackCfKey: String!, $jwt: String!) {
  getStack(ownerName: $ownerName, stackCfKey: $stackCfKey, jwt: $jwt) {
    ... on Stack {
      __typename
      audioFiles {
        altText
        url
        userDefinedName
      }
      code
      created
      dataFiles {
        altText
        url
        userDefinedName
      }
      filters
      ownerName
      publish
      stackCfKey
      stackId
      updated
      images {
        altText
        url
        userDefinedName
      }
    }
    ... on StackErrorMessage {
      __typename
      success
      message
    }
  }
}
    `;
export const GetStackCfKeysDocument = `
    query GetStackCfKeys($ownerName: String!, $jwt: String!) {
  getStackCfKeys(ownerName: $ownerName, jwt: $jwt) {
    ... on StackCfKeys {
      __typename
      stackCfKeys {
        key
        created
        updated
      }
    }
    ... on StackErrorMessage {
      __typename
      success
      message
    }
  }
}
    `;
export const GetStackIsPublishedDocument = `
    query GetStackIsPublished($ownerName: String!, $stackCfKey: String!, $jwt: String!) {
  getStackIsPublished(ownerName: $ownerName, stackCfKey: $stackCfKey, jwt: $jwt)
}
    `;
export const ImportPublicDomainImageDocument = `
    mutation ImportPublicDomainImage($fullImageUrl: String!, $title: String!, $source: String!, $jwt: String!, $ownerName: String!, $stackId: String!) {
  importPublicDomainImage(
    fullImageUrl: $fullImageUrl
    title: $title
    source: $source
    jwt: $jwt
    ownerName: $ownerName
    stackId: $stackId
  ) {
    ... on QpFile {
      __typename
      id
      url
      userDefinedName
      altText
    }
    ... on FileErrorMessage {
      __typename
      success
      message
    }
  }
}
    `;
export const GenerateLayoutDocument = `
    mutation GenerateLayout($prompt: String, $code: String, $image: String, $filter: String, $availableImages: String, $chatHistory: [AiChatMessageInput!], $locale: String) {
  generateLayout(
    prompt: $prompt
    code: $code
    image: $image
    filter: $filter
    availableImages: $availableImages
    chatHistory: $chatHistory
    locale: $locale
  ) {
    ... on AiChatResponse {
      __typename
      jadle
      explanation
    }
    ... on StackErrorMessage {
      __typename
      success
      message
    }
  }
}
    `;
export const SendMailDocument = `
    query SendMail($emailTo: String!, $emailStackCfKey: String!, $resendId: String!) {
  sendMail(
    emailTo: $emailTo
    emailStackCfKey: $emailStackCfKey
    resendId: $resendId
  ) {
    success
    message
  }
}
    `;
export const SearchPublicDomainImagesDocument = `
    query SearchPublicDomainImages($query: String!, $jwt: String!) {
  searchPublicDomainImages(query: $query, jwt: $jwt) {
    results {
      thumbnailUrl
      fullImageUrl
      title
      source
      sourcePageUrl
      license
    }
  }
}
    `;
export const UpdateFileDocument = `
    mutation UpdateFile($altText: String!, $cloudFlareName: String!, $fileName: String!, $fileType: String!, $id: String!, $jwt: String!, $ownerName: String!, $stackId: String!, $tags: [String!]!, $uploadedOn: Float!, $url: String!, $userDefinedName: String!, $bytes: Float) {
  updateFile(
    altText: $altText
    cloudFlareName: $cloudFlareName
    fileName: $fileName
    fileType: $fileType
    id: $id
    jwt: $jwt
    ownerName: $ownerName
    stackId: $stackId
    tags: $tags
    uploadedOn: $uploadedOn
    url: $url
    userDefinedName: $userDefinedName
    bytes: $bytes
  ) {
    success
    message
  }
}
    `;
export const DeleteFileDocument = `
    mutation DeleteFile($fileId: String!, $jwt: String!) {
  deleteFile(fileId: $fileId, jwt: $jwt) {
    success
    message
  }
}
    `;
export const UpdateFilterDocument = `
    mutation UpdateFilter($align: Align!, $autospace: Boolean!, $audioPlayer: AudioPlayerInput!, $background: String!, $borderBlockEnd: Float!, $borderInlineEnd: Float!, $borderInlineStart: Float!, $borderBlockStart: Float!, $borderColor: ColorChoice!, $blank: BlankInput!, $box: BoxInput!, $bullet: BulletInput!, $button: ButtonInput!, $caption: CaptionInput!, $cell: CellInput!, $tableCell: TableCellInput!, $color: String!, $colors: ColorsInput!, $cornerRadius: Float!, $decoration: TextDecoration!, $filterName: String!, $font: FontChoice!, $fonts: FontsInput!, $fontSize: FontSizeChoice!, $fontSizes: FontSizesInput!, $fontStyle: FontStyle!, $frame: FrameInput!, $grid: GridInput!, $image: ImageFilterInput!, $line: LineInput!, $lineHeightMultiplier: Float!, $link: LinkInput!, $list: ListInput!, $marginBottomMultiplier: Float!, $marginTopMultiplier: Float!, $ownerName: String!, $paddingBlockEnd: Float!, $paddingBlockStart: Float!, $paddingInlineEnd: Float!, $paddingInlineStart: Float!, $paragraph: ParagraphInput!, $publish: Boolean!, $read: ReadInput!, $stickyFooter: StickyFooterInput!, $stickyHeader: StickyHeaderInput!, $startingPoint: StartingPoint!, $subtitle: SubTitleInput!, $supertitle: SuperTitleInput!, $title: TitleInput!, $weight: FontWeight!, $columnTitle: ColumnTitleInput!, $table: TableInput!, $chart: ChartFilterInput!) {
  updateFilter(
    align: $align
    audioPlayer: $audioPlayer
    autospace: $autospace
    background: $background
    borderBlockEnd: $borderBlockEnd
    borderInlineEnd: $borderInlineEnd
    borderInlineStart: $borderInlineStart
    borderBlockStart: $borderBlockStart
    borderColor: $borderColor
    blank: $blank
    box: $box
    bullet: $bullet
    button: $button
    caption: $caption
    cell: $cell
    tableCell: $tableCell
    color: $color
    colors: $colors
    cornerRadius: $cornerRadius
    decoration: $decoration
    filterName: $filterName
    font: $font
    fonts: $fonts
    fontSize: $fontSize
    fontSizes: $fontSizes
    fontStyle: $fontStyle
    frame: $frame
    grid: $grid
    image: $image
    line: $line
    lineHeightMultiplier: $lineHeightMultiplier
    link: $link
    list: $list
    marginBottomMultiplier: $marginBottomMultiplier
    marginTopMultiplier: $marginTopMultiplier
    ownerName: $ownerName
    paddingBlockEnd: $paddingBlockEnd
    paddingBlockStart: $paddingBlockStart
    paddingInlineEnd: $paddingInlineEnd
    paddingInlineStart: $paddingInlineStart
    paragraph: $paragraph
    publish: $publish
    read: $read
    stickyFooter: $stickyFooter
    stickyHeader: $stickyHeader
    startingPoint: $startingPoint
    subtitle: $subtitle
    supertitle: $supertitle
    title: $title
    weight: $weight
    columnTitle: $columnTitle
    table: $table
    chart: $chart
  ) {
    success
    message
  }
}
    `;
export const DeleteStackDocument = `
    mutation DeleteStack($jwt: String!, $ownerName: String!, $stackCfKey: String!) {
  deleteStack(ownerName: $ownerName, stackCfKey: $stackCfKey, jwt: $jwt) {
    success
    message
  }
}
    `;
export const UpdateStackDocument = `
    mutation UpdateStack($audioFiles: [AudioFileInput!]!, $code: String, $created: Float!, $dataFiles: [DataFileInput!]!, $filters: [String!]!, $images: [ImageInput!]!, $jwt: String!, $navigationType: String!, $ownerName: String!, $publish: Boolean!, $stackCfKey: String!, $stackId: String!, $storyName: String, $updated: Float!) {
  updateStack(
    audioFiles: $audioFiles
    code: $code
    created: $created
    dataFiles: $dataFiles
    filters: $filters
    images: $images
    jwt: $jwt
    ownerName: $ownerName
    publish: $publish
    stackCfKey: $stackCfKey
    stackId: $stackId
    storyName: $storyName
    navigationType: $navigationType
    updated: $updated
  ) {
    success
    message
  }
}
    `;
export const RenameStackDocument = `
    mutation RenameStack($jwt: String!, $newStackCfKey: String!, $ownerName: String!, $stackCfKey: String!) {
  renameStack(
    jwt: $jwt
    newStackCfKey: $newStackCfKey
    ownerName: $ownerName
    stackCfKey: $stackCfKey
  ) {
    success
    message
  }
}
    `;
export const PublishStackDocument = `
    mutation PublishStack($jwt: String!, $stackCfKey: String!) {
  publishStack(stackCfKey: $stackCfKey, jwt: $jwt) {
    success
    message
  }
}
    `;
export const UnPublishStackDocument = `
    mutation UnPublishStack($jwt: String!, $stackCfKey: String!) {
  unPublishStack(stackCfKey: $stackCfKey, jwt: $jwt) {
    success
    message
  }
}
    `;
export const WriteUserRecordDocument = `
    mutation WriteUserRecord($id: String!, $recordType: String!, $stack: String!, $stackId: String!, $value: String!, $created: Float!) {
  writeUserRecord(
    id: $id
    recordType: $recordType
    stack: $stack
    stackId: $stackId
    value: $value
    created: $created
  ) {
    success
    message
  }
}
    `;
export const ViewFileDocument = `
    query ViewFile($id: String!) {
  viewFile(id: $id) {
    altText
    url
    userDefinedName
  }
}
    `;
export const ViewStackDocument = `
    query ViewStack($stackCfKey: String!) {
  viewStack(stackCfKey: $stackCfKey) {
    code
    filters
    stackId
    hideAttribution
    audioFiles {
      userDefinedName
      url
      altText
    }
    dataFiles {
      userDefinedName
      url
      altText
    }
    images {
      userDefinedName
      url
      altText
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    GenerateAiImage(variables: SDK_GenerateAiImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_GenerateAiImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_GenerateAiImageMutation>({ document: GenerateAiImageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GenerateAiImage', 'mutation', variables);
    },
    GetFile(variables: SDK_GetFileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_GetFileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_GetFileQuery>({ document: GetFileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetFile', 'query', variables);
    },
    GetFiles(variables: SDK_GetFilesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_GetFilesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_GetFilesQuery>({ document: GetFilesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetFiles', 'query', variables);
    },
    GetFilterNames(variables: SDK_GetFilterNamesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_GetFilterNamesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_GetFilterNamesQuery>({ document: GetFilterNamesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetFilterNames', 'query', variables);
    },
    GetFilter(variables: SDK_GetFilterQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_GetFilterQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_GetFilterQuery>({ document: GetFilterDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetFilter', 'query', variables);
    },
    GetFont(variables: SDK_GetFontQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_GetFontQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_GetFontQuery>({ document: GetFontDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetFont', 'query', variables);
    },
    GetStack(variables: SDK_GetStackQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_GetStackQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_GetStackQuery>({ document: GetStackDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetStack', 'query', variables);
    },
    GetStackCfKeys(variables: SDK_GetStackCfKeysQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_GetStackCfKeysQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_GetStackCfKeysQuery>({ document: GetStackCfKeysDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetStackCfKeys', 'query', variables);
    },
    GetStackIsPublished(variables: SDK_GetStackIsPublishedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_GetStackIsPublishedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_GetStackIsPublishedQuery>({ document: GetStackIsPublishedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetStackIsPublished', 'query', variables);
    },
    ImportPublicDomainImage(variables: SDK_ImportPublicDomainImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_ImportPublicDomainImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_ImportPublicDomainImageMutation>({ document: ImportPublicDomainImageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ImportPublicDomainImage', 'mutation', variables);
    },
    GenerateLayout(variables?: SDK_GenerateLayoutMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_GenerateLayoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_GenerateLayoutMutation>({ document: GenerateLayoutDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GenerateLayout', 'mutation', variables);
    },
    SendMail(variables: SDK_SendMailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_SendMailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_SendMailQuery>({ document: SendMailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SendMail', 'query', variables);
    },
    SearchPublicDomainImages(variables: SDK_SearchPublicDomainImagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_SearchPublicDomainImagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_SearchPublicDomainImagesQuery>({ document: SearchPublicDomainImagesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SearchPublicDomainImages', 'query', variables);
    },
    UpdateFile(variables: SDK_UpdateFileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_UpdateFileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_UpdateFileMutation>({ document: UpdateFileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateFile', 'mutation', variables);
    },
    DeleteFile(variables: SDK_DeleteFileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_DeleteFileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_DeleteFileMutation>({ document: DeleteFileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteFile', 'mutation', variables);
    },
    UpdateFilter(variables: SDK_UpdateFilterMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_UpdateFilterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_UpdateFilterMutation>({ document: UpdateFilterDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateFilter', 'mutation', variables);
    },
    DeleteStack(variables: SDK_DeleteStackMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_DeleteStackMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_DeleteStackMutation>({ document: DeleteStackDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteStack', 'mutation', variables);
    },
    UpdateStack(variables: SDK_UpdateStackMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_UpdateStackMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_UpdateStackMutation>({ document: UpdateStackDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateStack', 'mutation', variables);
    },
    RenameStack(variables: SDK_RenameStackMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_RenameStackMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_RenameStackMutation>({ document: RenameStackDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RenameStack', 'mutation', variables);
    },
    PublishStack(variables: SDK_PublishStackMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_PublishStackMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_PublishStackMutation>({ document: PublishStackDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PublishStack', 'mutation', variables);
    },
    UnPublishStack(variables: SDK_UnPublishStackMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_UnPublishStackMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_UnPublishStackMutation>({ document: UnPublishStackDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UnPublishStack', 'mutation', variables);
    },
    WriteUserRecord(variables: SDK_WriteUserRecordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_WriteUserRecordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_WriteUserRecordMutation>({ document: WriteUserRecordDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'WriteUserRecord', 'mutation', variables);
    },
    ViewFile(variables: SDK_ViewFileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_ViewFileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_ViewFileQuery>({ document: ViewFileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ViewFile', 'query', variables);
    },
    ViewStack(variables: SDK_ViewStackQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SDK_ViewStackQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SDK_ViewStackQuery>({ document: ViewStackDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ViewStack', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;